import React from "react";
import assets from "../../assets/assets";
import "./footer.css";

export default function Footer() {
    return (
        <div className="footer">
         <p>© 2025 Sleem. All rights reserved</p>
         <ul>
            <li>Terms of Services</li>
            <li>Privacy Policy</li>
         </ul>
        </div>
    );
}
